export interface GeoJsonObject {
  type: string
  properties?: Properties
  geometry?: Geometry
  features?: Feature[]
}

export interface Feature {
  type: string
  properties?: Properties
  geometry?: Geometry
}

export interface Properties {
  id?: number
  end?: any
  type?: string
  start?: any
  weight?: string
  distance?: string
  polyline?: any
  "connection-ids"?: number[]
  "intersection-ids"?: number[]
  "town-segment-ids"?: number[]
  code?: string
  name?: string
  merge?: any
  demand?: boolean
  radius?: number
  direction?: number
  inflexion?: boolean
  bidirectional?: any
  properties?: Properties
  geometry?: Geometry
  outlineColor?: string
  terrainColor?: string
}

export function isOutlineDrawn(outline?: GeoJsonObject | null): boolean {
  return !!outline?.geometry?.coordinates?.[0];
}

export interface Geometry {
  type: string
  coordinates: number[][][] | any
}
